export const akunSubCategoryFormData = (dropdownAkunCategory) => {
    return [
        {
            id  : "sub_kategori_akun",
            label: "Sub Akun Kategori",
            fields: [{
                type: "input",
                placeholder: "Masukan Nama Sub Akun Kategori"
            }]
        },
        {
            id : "id_akun_kategori",
            label : "Pilih Akun Kategori",
            fields : [{
                type: "option",
                options: dropdownAkunCategory
            }]
        }
    ]
}